import { useEffect, useState } from 'react';
import { useSession } from 'next-auth/react';

type UseEventSourceProps = {
	url: string;
};

type EventSourceState = {
	data: string | null;
	error: string | null;
};

export const useEventSource = ({ url }: UseEventSourceProps) => {
	const session = useSession();
	const token = session.data?.accessToken;
	const [state, setState] = useState<EventSourceState>({
		data: null,
		error: null,
	});

	useEffect(() => {
		if (!token) return;
		const eventSource = new EventSource(`${url}`);

		eventSource.onopen = () => {
			console.log('SSE connection opened.');
		};

		eventSource.onmessage = (event) => {
			setState({ data: event.data, error: null });
		};

		eventSource.onerror = () => {
			const error = 'An error occurred while receiving updates.';
			console.log('Event error', error);
		};

		return () => {
			eventSource.close();
		};
	}, [url, token]);

	return state;
};
